import React, { useState } from 'react';
import { MdArrowBack, MdFlight, MdCheckCircle, MdCreditCard, MdInfoOutline } from 'react-icons/md';
import { useProfile } from '../contexts/ProfileContext';

const POPULAR = [
  { code: 'US', label: 'United States' },
  { code: 'MX', label: 'Mexico' },
  { code: 'GB', label: 'United Kingdom' },
  { code: 'FR', label: 'France' },
  { code: 'IT', label: 'Italy' },
  { code: 'JP', label: 'Japan' },
];

const todayPlus = (days) => {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
};

const TravelNoticeScreen = ({ onNavigate, onBack }) => {
  const { loadedProfileData } = useProfile();
  const accounts = loadedProfileData?.profile?.accounts || {};

  const cards = [];
  if (accounts.credit_card?.account_number) {
    cards.push({ id: 'credit', label: 'TD Cash Back Visa', last4: String(accounts.credit_card.account_number).slice(-4) });
  }
  if (accounts.chequing?.account_number) {
    cards.push({ id: 'debit', label: 'TD Access Card', last4: String(accounts.chequing.account_number).slice(-4) });
  }
  if (cards.length === 0) {
    cards.push({ id: 'visa', label: 'TD Cash Back Visa', last4: '4421' });
    cards.push({ id: 'access', label: 'TD Access Card', last4: '8810' });
  }

  const [country,  setCountry]  = useState('');
  const [start,    setStart]    = useState(todayPlus(1));
  const [end,      setEnd]      = useState(todayPlus(14));
  const [selected, setSelected] = useState(cards.map(c => c.id));
  const [done,     setDone]     = useState(false);

  const toggleCard = (id) =>
    setSelected(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);

  const canSubmit = country.trim().length > 1 && selected.length > 0 && start <= end;

  if (done) {
    return (
      <div className="screen bh-flow">
        <header className="bh-flow-hero">
          <div className="bh-flow-hero-left">
            <button className="bh-flow-back" onClick={onBack || (() => onNavigate('cards'))} aria-label="Back to cards">
              <MdArrowBack />
            </button>
            <h1 className="bh-flow-title">Travel notice set</h1>
          </div>
        </header>
        <div className="bh-flow-body" style={{ alignItems: 'center', textAlign: 'center' }}>
          <div className="bh-success-icon">
            <MdCheckCircle size={56} color="var(--td-green)" />
          </div>
          <div className="bh-success-title">You're all set</div>
          <div className="bh-success-subtitle">
            We won't flag transactions in {country} between {start} and {end}.
          </div>
          <div className="bh-btn-row" style={{ width: '100%', marginTop: 'var(--space-md)' }}>
            <button className="bh-btn-outline-dark" onClick={() => onNavigate('cards')}>Back to cards</button>
            <button className="bh-btn-primary" onClick={() => onNavigate('home')}>Done</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="screen bh-flow">
      <header className="bh-flow-hero">
        <div className="bh-flow-hero-left">
          <button className="bh-flow-back" onClick={onBack || (() => onNavigate('cards'))} aria-label="Back to cards">
            <MdArrowBack />
          </button>
          <h1 className="bh-flow-title">Travel Notice</h1>
        </div>
        <MdFlight size={22} style={{ color: 'var(--bh-black)' }} />
      </header>

      <div className="bh-flow-body">
        <div className="bh-form-card">
          <div className="bh-form-card-title">Where are you going?</div>
          <div className="bh-field">
            <label className="bh-field-label" htmlFor="travel-country">Destination</label>
            <input
              id="travel-country"
              className="bh-field-input"
              type="text"
              placeholder="e.g. Spain, Japan, United States"
              value={country}
              onChange={(e) => setCountry(e.target.value)}
            />
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 'var(--space-2xs)' }}>
            {POPULAR.map(p => (
              <button
                key={p.code}
                type="button"
                className={`bh-quick-amount${country === p.label ? ' selected' : ''}`}
                onClick={() => setCountry(p.label)}
              >
                {p.label}
              </button>
            ))}
          </div>
        </div>

        <div className="bh-form-card">
          <div className="bh-form-card-title">Dates</div>
          <div style={{ display: 'flex', gap: 'var(--space-sm)' }}>
            <div className="bh-field" style={{ flex: 1 }}>
              <label className="bh-field-label" htmlFor="travel-start">Start</label>
              <input id="travel-start" className="bh-field-input" type="date" value={start} onChange={(e) => setStart(e.target.value)} />
            </div>
            <div className="bh-field" style={{ flex: 1 }}>
              <label className="bh-field-label" htmlFor="travel-end">End</label>
              <input id="travel-end" className="bh-field-input" type="date" value={end} onChange={(e) => setEnd(e.target.value)} />
            </div>
          </div>
          {start > end && (
            <div className="bh-field-error">End date must be after the start date.</div>
          )}
        </div>

        <div className="bh-form-card">
          <div className="bh-form-card-title">Cards to cover</div>
          {cards.map(c => {
            const on = selected.includes(c.id);
            return (
              <button
                key={c.id}
                type="button"
                onClick={() => toggleCard(c.id)}
                style={{
                  display: 'flex', alignItems: 'center', gap: 'var(--space-sm)',
                  padding: 'var(--space-sm)', background: on ? 'rgba(47,191,0,0.08)' : 'var(--bh-white)',
                  border: '1px solid ' + (on ? 'var(--td-green)' : 'var(--bh-border)'),
                  borderRadius: 'var(--radius-md)', cursor: 'pointer', textAlign: 'left',
                }}
                aria-pressed={on}
              >
                <span style={{
                  width: 36, height: 36, background: 'var(--td-premium)', color: 'var(--bh-white)',
                  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                  borderRadius: 'var(--radius-md)', flexShrink: 0,
                }}>
                  <MdCreditCard size={18} />
                </span>
                <div style={{ flex: 1 }}>
                  <div style={{ font: 'var(--bh-body)', fontWeight: 600, color: 'var(--bh-black)' }}>{c.label}</div>
                  <div style={{ font: 'var(--bh-caption)', color: 'var(--bh-gray)' }}>•••• {c.last4}</div>
                </div>
                <span style={{
                  width: 22, height: 22,
                  borderRadius: 'var(--radius-full)',
                  border: '2px solid ' + (on ? 'var(--td-green)' : 'var(--bh-border)'),
                  background: on ? 'var(--td-green)' : 'transparent',
                  display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                }}>
                  {on && <MdCheckCircle size={14} color="var(--bh-white)" />}
                </span>
              </button>
            );
          })}
        </div>

        <div className="bh-info-box">
          <MdInfoOutline size={16} style={{ verticalAlign: 'middle', marginRight: 6 }} />
          We use travel notices to lower the chance your card is blocked abroad. Most fraud rules
          still apply — call us right away if a card stops working.
        </div>

        <button
          className="bh-btn-cta"
          disabled={!canSubmit}
          onClick={() => setDone(true)}
        >
          Set travel notice
        </button>
      </div>
    </div>
  );
};

export default TravelNoticeScreen;
